import { useEffect, useState } from "react";
import api from "../lib/api";

export default function CryptoTicker() {
  const [coins, setCoins] = useState([]);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const { data } = await api.get("/crypto/prices");
        if (mounted) setCoins(data || []);
      } catch (e) {
        // silent fail
      }
    };
    load();
    const t = setInterval(load, 60_000);
    return () => { mounted = false; clearInterval(t); };
  }, []);

  if (!coins || coins.length === 0) {
    return (
      <div className="w-full bg-[#111111] text-white/60 text-xs font-mono py-2 px-4" data-testid="crypto-ticker-empty">
        <span className="tracking-widest uppercase">Loading live crypto prices…</span>
      </div>
    );
  }

  const row = [...coins, ...coins];

  return (
    <div className="w-full bg-[#111111] text-white overflow-hidden border-b border-white/10" data-testid="crypto-ticker">
      <div className="flex items-center py-2">
        <div className="shrink-0 px-4 border-r border-white/20 text-[10px] font-mono uppercase tracking-[0.25em] text-white/70">
          LIVE · CoinGecko
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex gap-8 whitespace-nowrap animate-marquee font-mono text-sm">
            {row.map((c, idx) => {
              const up = (c.change_24h || 0) >= 0;
              return (
                <div key={`${c.id}-${idx}`} className="flex items-center gap-2" data-testid={`ticker-${c.symbol}`}>
                  <span className="font-bold">{c.symbol}</span>
                  <span className="text-white/90">${c.price?.toLocaleString(undefined, { maximumFractionDigits: c.price < 1 ? 4 : 2 })}</span>
                  <span className={up ? "text-emerald-400" : "text-red-400"}>
                    {up ? "▲" : "▼"} {Math.abs(c.change_24h || 0).toFixed(2)}%
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
